import Avatar from '@berlitzplatforms/micro.ui.avatar-legacy'
import Delete2 from '@berlitz/streamline-icons/lib/bold/01-Interface-Essential/23-Delete/Delete2'
import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { AvatarName, AvatarWrapper, DeleteIcon } from './style'
import Spacer from '@berlitz/spacer'

interface AvatarWithNameProps {
  data?: Record<string, unknown>
  name?: string
  image?: string
  fave?: boolean
  loading?: boolean
  isEditMode?: boolean
  onClickName?: () => void
  onClickAvatar?: () => void
  onClickIcon?: () => void
  customFaveIcon?: React.ReactNode
}

const noop = () => {}

const AvatarWithName: React.FC<AvatarWithNameProps> = ({
  name = '',
  onClickName = noop,
  onClickAvatar = noop,
  onClickIcon = noop,
  fave,
  loading,
  isEditMode,
  image,
  customFaveIcon,
}) => {
  const nSplit = name.split(' ')
  const firstN = nSplit[0]
  const lastN = nSplit[1]
  return (
    <>
      <AvatarWrapper>
        <Avatar
          img={image}
          size="56px"
          faved={fave}
          grayedDefault
          type={'profile'}
          onClick={isEditMode ? undefined : onClickAvatar}
          isLoading={loading}
          loadingType="skeleton"
          customFaveIcon={
            customFaveIcon ? (
              customFaveIcon
            ) : isEditMode ? (
              <DeleteIcon>
                <Delete2 />
              </DeleteIcon>
            ) : null
          }
          onClickFaveIcon={onClickIcon}
        />
        <Spacer size="xxs" />
        <AvatarName isEditMode={isEditMode}>
          {loading ? (
            <>
              <div>
                <Skeleton width={'50px'} height={'13px'} />
              </div>
              <div>
                <Skeleton width={'70px'} height={'13px'} />
              </div>
            </>
          ) : (
            <>
              <div onClick={onClickName}>{firstN}</div>
              <div onClick={onClickName}>{lastN}</div>
            </>
          )}
        </AvatarName>
      </AvatarWrapper>
    </>
  )
}

export default AvatarWithName
